// extracted by mini-css-extract-plugin
export default {"root":"ShuttleSheetTypeForm_root__+q0p6"};